import { create } from 'zustand';

export interface PendingSiteVisitRecordingUpload {
	clientSessionId: string;
	siteId: number;
	durationMs: number;
	audio: Blob;
	mimeType: string;
	membershipno?: string | null;
	bdeCode?: string | null;
	cmdiName?: string | null;
	sfid?: string | null;
}

interface SiteVisitRecordingUploadStore {
	pending: PendingSiteVisitRecordingUpload | null;
	setPendingRecording: (value: PendingSiteVisitRecordingUpload) => void;
	clearPendingRecording: () => void;
}

export const useSiteVisitRecordingUploadStore = create<SiteVisitRecordingUploadStore>((set) => ({
	pending: null,
	setPendingRecording: (value): void => set({ pending: value }),
	clearPendingRecording: (): void => set({ pending: null }),
}));
